/**
 * @file 积分不足弹窗 - 变体（variant）计算 hook
 * @description
 * 弹窗根据用户角色和会员等级渲染不同的 UI 变体（文案 + 按钮组合），
 * 本 hook 负责计算当前应展示哪种变体。
 */

import {useContextMemberInfo} from '@/commerce/benefit';
import {useIsProducer} from '@/hooks/useIsProducer';
import {MemberLevelValue} from '@/services/commerce/type';

/**
 * 积分不足弹窗变体
 * - projectNonProducer: 项目维度下的非制片人，仅提示联系制片人
 * - nonMember: 免费用户，引导开通会员或充值积分
 * - nonTopMember: 非顶级会员，引导升级会员或充值积分
 * - topMember: 顶级会员，仅引导充值积分
 */
export type PointsModalVariant = 'projectNonProducer' | 'nonMember' | 'nonTopMember' | 'topMember';

/**
 * 根据当前上下文计算弹窗变体
 * 优先级：项目维度角色判断 > 会员等级判断
 */
export const useModalVariant = (): PointsModalVariant => {
    const isProducer = useIsProducer();
    const {memberInfo} = useContextMemberInfo();

    // 项目维度 + 非制片人：无权自行充值，只能联系制片人
    if (!isProducer) return 'projectNonProducer';

    // 个人维度 or 项目维度制片人 → 按会员等级区分引导策略
    const memberLevel = memberInfo?.memberLevel;
    if (memberLevel === undefined || memberLevel === MemberLevelValue.FREE) return 'nonMember';
    if (memberLevel === MemberLevelValue.FLAGSHIP) return 'topMember';
    return 'nonTopMember';
};
